import { pageInfo, initPage, saveData, initUpdate, editData, deleteData, exportData, orderBasicDetailsInfo, initOrderApprovedData, uploadSo, templateSo, uploadItr, templateItr, uploadOrder, templateOrder, fileDownload, approveAgree, batchApproveAgree, refuseApproved, uploadSoResult, uploadOrderResult, uploadItrResult, uploadDomesticOrder, templateDomesticOrder, uploadDomesticOrderResult, send } from './../api'
import { selectOrderStatus, selectOrderType, selectOrderRejectReason } from '../../../../api'
const shipApprove = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    initUpdateObj: null,
    deleteResp: null,
    exportObj: null,
    orderBasicInfoObj: null,
    orderListObj: null,
    uploadSoResp: null,
    templateSoObj: null,
    uploadItrResp: null,
    templateItrObj: null,
    uploadOrderResp: null,
    templateOrderObj: null,
    fileObj: null,
    uploadSoResultResp: null,
    uploadITrResultObj: null,
    uploadOrderResultObj: null,
    agreeObj: null,
    batchAgreeObj: null,
    refuseObj: null,
    uploadDomesticOrderResp: null,
    templateDomesticOrderObj: null,
    uploadDomesticOrderResultObj: null,
    orderStatusObj: null,
    orderTypeObj: null,
    orderRejectReasonObj: null,
    send: null
  },
  mutations: {

    PAGE_INFO(state, data) {
      state.total = data.total
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [item.isCanSplit == 'N'] }))
    },
    INIT_PAGE(state, data) {
      state.initPageObj = data.obj || {}
    },
    SAVE_DATA(state, data) {
      state.addResp = data
    },
    INIT_UPDATE(state, data) {
      state.initUpdateObj = data.obj || {}
    },
    EDIT_DATA(state, data) {
      state.editResp = data
    },
    DELETE_DATA(state, data) {
      state.deleteResp = data
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data
    },

    ORDERBASIC_DETAILS_INFO(state, resp) {
      state.orderBasicInfoObj = resp.obj || {}
    },
    ORDER_LIST(state, data) {
      state.orderListObj = data
    },
    UPLOAD_SODATA(state, data) {
      state.uploadSoResp = data
    },
    DOWN_LOAD_SOTEMPLATE(state, data) {
      state.templateSoObj = data
    },
    UPLOAD_ITRDATA(state, data) {
      state.uploadItrResp = data
    },
    DOWN_LOAD_ITRTEMPLATE(state, data) {
      state.templateItrObj = data
    },
    UPLOAD_ORDERDATA(state, data) {
      state.uploadOrderResp = data
    },
    DOWN_LOAD_ORDERTEMPLATE(state, data) {
      state.templateOrderObj = data
    },
    FILE_DATA(state, data) {
      state.fileObj = data
    },
    UPLOAD_SO_RESULT(state, data) {
      state.uploadSoResultResp = data
    },
    UPLOAD_ITR_RESULT(state, data) {
      state.uploadITrResultObj = data
    },
    UPLOAD_ORDER_RESULT(state, data) {
      state.uploadOrderResultObj = data
    },
    AGREE_DATA(state, data) {
      state.agreeObj = data
    },
    BATCH_AGREE_DATA(state, data) {
      state.batchAgreeObj = data
    },
    REFUSE_DATA(state, data) {
      state.refuseObj = data
    },
    UPLOAD_DOMESTIC_ORDERDATA(state, data) {
      state.uploadDomesticOrderResp = data
    },
    DOWNLOAD_DOMESTIC_ORDERTEMPLATE(state, data) {
      state.templateDomesticOrderObj = data
    },
    UPLOAD_DOMESTICORDER__RESULT(state, data) {
      state.uploadDomesticOrderResultObj = data
    },
    ORDER_STATUS(state, data) {
      state.orderStatusObj = data.obj || {}
    },
    ORDER_TYPE(state, data) {
      state.orderTypeObj = data.obj || {}
    },
    ORDER_REJECT_REASON(state, data) {
      state.orderRejectReasonObj = data.obj || {}
    },
    ORDER_SEND(state, data) {
      state.send = data.obj || {}
    }
  },
  actions: {
    // 查询事件
    async pageInfo({ commit }, obj) {
      const resp = await pageInfo(obj)
      commit('PAGE_INFO', resp)
    },
    // 初始化页面事件
    async initPage({ commit }, obj) {
      const resp = await initPage(obj)
      commit('INIT_PAGE', resp)
    },
    // 新增保存事件
    async saveData({ commit }, obj) {
      const resp = await saveData(obj)
      commit('SAVE_DATA', resp)
    },
    // 初始化更新对象事件
    async initUpdate({ commit }, obj) {
      const resp = await initUpdate(obj)
      commit('INIT_UPDATE', resp)
    },
    // 修改保存事件
    async editData({ commit }, obj) {
      const resp = await editData(obj)
      commit('EDIT_DATA', resp)
    },
    // 删除数据事件
    async deleteData({ commit }, obj) {
      const resp = await deleteData(obj)
      commit('DELETE_DATA', resp)
    },

    // 导出数据
    async exportData({ commit }, obj) {
      const resp = await exportData(obj)
      commit('EXPORT_DATA', resp)
    },

    // 基本信息
    async orderBasicDetailsInfo({ commit }, obj) {
      const resp = await orderBasicDetailsInfo(obj)
      commit('ORDERBASIC_DETAILS_INFO', resp)
    },
    // 订单数据初始化
    async initOrderApprovedData({ commit }, obj) {
      const resp = await initOrderApprovedData(obj)
      commit('ORDER_LIST', resp)
    },
    // 导入so数据
    async uploadSo({ commit }, obj) {
      const resp = await uploadSo(obj)
      commit('UPLOAD_SODATA', resp)
    },
    // 下载so模板
    async templateSo({ commit }, obj) {
      const resp = await templateSo(obj)
      commit('DOWN_LOAD_SOTEMPLATE', resp)
    },
    // 导入itr数据
    async uploadItr({ commit }, obj) {
      const resp = await uploadItr(obj)
      commit('UPLOAD_ITRDATA', resp)
    },
    // 下载itr模板
    async templateItr({ commit }, obj) {
      const resp = await templateItr(obj)
      commit('DOWN_LOAD_ITRTEMPLATE', resp)
    },
    // 导入订单数据
    async uploadOrder({ commit }, obj) {
      const resp = await uploadOrder(obj)
      commit('UPLOAD_ORDERDATA', resp)
    },
    // 下载订单模板
    async templateOrder({ commit }, obj) {
      const resp = await templateOrder(obj)
      commit('DOWN_LOAD_ORDERTEMPLATE', resp)
    },
    // 附件下载
    async fileDownload({ commit }, obj) {
      const resp = await fileDownload(obj)
      commit('FILE_DATA', resp)
    },
    // 下载导入So结果文件
    async uploadSoResult({ commit }, obj) {
      const resp = await uploadSoResult(obj)
      commit('UPLOAD_SO_RESULT', resp)
    },
    // 下载导入Itr结果文件
    async uploadItrResult({ commit }, obj) {
      const resp = await uploadItrResult(obj)
      commit('UPLOAD_ITR_RESULT', resp)
    },
    // 下载导入订单结果文件
    async uploadOrderResult({ commit }, obj) {
      const resp = await uploadOrderResult(obj)
      commit('UPLOAD_ORDER_RESULT', resp)
    },

    // 同意
    async approveAgree({ commit }, obj) {
      const resp = await approveAgree(obj)
      commit('AGREE_DATA', resp)
    },
    // 批量同意
    async batchApproveAgree({ commit }, obj) {
      const resp = await batchApproveAgree(obj)
      commit('BATCH_AGREE_DATA', resp)
    },
    // 拒绝
    async refuseApproved({ commit }, obj) {
      const resp = await refuseApproved(obj)
      commit('REFUSE_DATA', resp)
    },
    // 导入订单数据[国内订单类型]
    async uploadDomesticOrder({ commit }, obj) {
      const resp = await uploadDomesticOrder(obj)
      commit('UPLOAD_DOMESTIC_ORDERDATA', resp)
    },
    // 下载订单模板[国内订单类型]
    async templateDomesticOrder({ commit }, obj) {
      const resp = await templateDomesticOrder(obj)
      commit('DOWNLOAD_DOMESTIC_ORDERTEMPLATE', resp)
    },
    // 下载订单模板[国内订单类型]结果文件
    async uploadDomesticOrderResult({ commit }, obj) {
      const resp = await uploadDomesticOrderResult(obj)
      commit('UPLOAD_DOMESTICORDER__RESULT', resp)
    },
    async selectOrderStatus({ commit }, obj) {
      const resp = await selectOrderStatus(obj)
      commit('ORDER_STATUS', resp)
    },
    async selectOrderType({ commit }, obj) {
      const resp = await selectOrderType(obj)
      commit('ORDER_TYPE', resp)
    },
    async selectOrderRejectReason({ commit }, obj) {
      const resp = await selectOrderRejectReason(obj)
      commit('ORDER_REJECT_REASON', resp)
    },
    async send({ commit }, obj) {
      const resp = await send(obj)
      commit('ORDER_SEND', resp)
    }
  }
}
export default shipApprove



// WEBPACK FOOTER //
// ./src/page/order/shipApprove/store/shipApprove.store.js